import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DotsEditCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0", clipRule: "evenodd" })));
}
const DotsEditCustom = forwardRef(_DotsEditCustom);
export { DotsEditCustom };
